import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {api} from "../../../api/api";
import UploadJobsModal from "../../job/upload/UploadJobsModal";

interface IState {
	uploadJobsModalVisible: boolean
	isLoading: boolean
}

export default class BulkJobManagement extends React.PureComponent<{}, IState> {

	constructor(props: {}) {
		super(props);
		this.state = {uploadJobsModalVisible: false, isLoading: false};
	}

	render() {
		return (
			<div>
				<PageHeaderView header={"Bulk Job Management"}>
					<ButtonPrimary onClick={this.downloadJobsXls}
								   label={"Download Jobs"}
								   variant={"burgundy"}
								   disabled={this.state.isLoading}
								   isLoading={this.state.isLoading}/>
					<ButtonPrimary onClick={this.openUploadJobsModal}
								   label={"Upload Jobs"}
								   variant={"burgundy"}
								   customStyles={{marginLeft: "10px"}}/>
				</PageHeaderView>
				{this.state.uploadJobsModalVisible &&
				<UploadJobsModal onClose={this.closeUploadJobsModal}/>}
			</div>
		)
	}

	downloadJobsXls = () => {
		this.setState({isLoading: true}, () => {
			const cancelLoading = () => this.setState({isLoading: false});
			api.instance.jobApi.downloadJobs().then(cancelLoading).catch((e) => {
				notifyBugsnagAndShowToast(e, "Cannot download jobs", "Jobs download");
				cancelLoading()
			})
		});
	}

	openUploadJobsModal = () => this.setState({uploadJobsModalVisible: true});

	closeUploadJobsModal = () => this.setState({uploadJobsModalVisible: false})
}
